import React from 'react';
import './ModellingAgency.css';

const roadmapItems = [
  {
    id: 'guitar',
    title: 'Guitar Amp & Cab Modeling',
    description: 'Master digital amp sims, cabinet IRs, and signal chain fundamentals',
    active: true,
  },
  {
    id: 'bass',
    title: 'Bass Tone Sculpting',
    description: 'Craft powerful low-end with modern modeling tools',
    active: false,
  },
  {
    id: 'drums',
    title: 'Drums & Percussion',
    description: 'Shape your rhythm section with modern modeling tools',
    active: false,
  },
  {
    id: 'vocals',
    title: 'Vocal Production',
    description: 'Professional vocal chains and creative effects',
    active: false,
  },
];

function ModellingAgency() {
  return (
    <section id="modelling-agency" className="agency">
      <div className="container agency-content">
        <h2 className="services-title">Services</h2>
        <div className="agency-header">
          <span className="agency-label">Introducing</span>
          <img src="/assets/modelling-agency-logo.png" alt="Modelling Agency" className="agency-logo" />
          <p className="agency-tagline">Take control of digital tone</p>
          <p className="agency-intro">
            A play on tradition. Not runway models—digital models. Amp sims, cab IRs,
            and the tools that shape modern sound. But here's the difference: we don't
            just teach the plugins and physical modellers. We put you in front of the real amps, cabs, mics,
            and preamps—so you hear what the digital world is trying to emulate.
            We give you the knowledge. You take the agency.
          </p>
        </div>

        <div className="agency-service">
          <div className="service-card">
            <div className="service-icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 21V19C17 16.7909 15.2091 15 13 15H5C2.79086 15 1 16.7909 1 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M23 21V19C22.9986 17.1771 21.765 15.5857 20 15.13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M16 3.13C17.7699 3.58317 19.0078 5.17787 19.0078 7.005C19.0078 8.83213 17.7699 10.4268 16 10.88" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="service-info">
              <h3 className="service-title">1-on-1 Coaching</h3>
              <p className="service-description">
                In-person sessions tailored to your setup, your genre, and your goals.
                Hands-on time with real analog gear and the latest digital tools—side by side.
              </p>
            </div>
            <a href="#contact" className="service-cta">Inquire</a>
          </div>
        </div>

        <div className="agency-differentiators">
          <div className="differentiator">
            <div className="differentiator-icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2"/>
                <path d="M12 6V12L16 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </div>
            <h4 className="differentiator-title">In-Person Sessions</h4>
            <p className="differentiator-text">Real-time guidance in a professional studio environment</p>
          </div>
          <div className="differentiator">
            <div className="differentiator-icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="8" width="16" height="12" rx="2" stroke="currentColor" strokeWidth="2"/>
                <path d="M8 8V6C8 4.89543 8.89543 4 10 4H14C15.1046 4 16 4.89543 16 6V8" stroke="currentColor" strokeWidth="2"/>
                <circle cx="12" cy="14" r="2" stroke="currentColor" strokeWidth="2"/>
              </svg>
            </div>
            <h4 className="differentiator-title">Real Analog Gear</h4>
            <p className="differentiator-text">18 Tube Amps • 16 Cabs • Studio mics & preamps by Neumann, Neve, Burl</p>
          </div>
          <div className="differentiator">
            <div className="differentiator-icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 6H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                <path d="M8 12H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                <path d="M8 18H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                <path d="M3 6H3.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                <path d="M3 12H3.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                <path d="M3 18H3.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </div>
            <h4 className="differentiator-title">Hear the Source</h4>
            <p className="differentiator-text">A/B compare analog and digital—understand what the models emulate</p>
          </div>
        </div>

        <div className="agency-roadmap">
          <h3 className="roadmap-title">The Roadmap</h3>
          <div className="roadmap-track">
            {roadmapItems.map((item, index) => (
              <div
                key={item.id}
                className={`roadmap-item ${item.active ? 'active' : 'upcoming'}`}
              >
                <div className="roadmap-marker">
                  <span className="marker-dot" />
                  {index < roadmapItems.length - 1 && <span className="marker-line" />}
                </div>
                <div className="roadmap-content">
                  <h4 className="roadmap-item-title">{item.title}</h4>
                  <p className="roadmap-item-description">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default ModellingAgency;
